import type { IconSvgObject } from './types';

const MirrorIcon: IconSvgObject = [
  ["path", { d: "M7 7V16C7 16.5523 7.44772 17 8 17H16C16.5523 17 17 16.5523 17 16V7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 6L11 5M11 8.5L13 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20 8V22M4 8V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M4 20H20", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M4 12H7M17 12H20", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default MirrorIcon;
